import React from "react";

class EventHelpers {
  static preventDefault(event: React.MouseEvent<any, MouseEvent>) {
    event.preventDefault();
  }
  static stopPropagation(
    event: React.MouseEvent<any, MouseEvent> | React.FocusEvent<any> | React.KeyboardEvent<any> | React.TouchEvent<any>
  ) {
    event.stopPropagation();
  }

  static onKeyDownDisableBackspaceDelete(event: React.KeyboardEvent<any>) {
    if (event.key === "Backspace" || event.key === "Delete") {
      event.stopPropagation();
    }
  }
  /** Handle keydown events to prevent default behavior for Tab and Shift keys */
  static preventTabAndShiftDefault(event: React.KeyboardEvent | React.MouseEvent) {
    if (
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" || (event as React.KeyboardEvent).key === "Shift")
    ) {
      event.preventDefault();
    }
  }
}
export default EventHelpers;
